import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import * as riskService from '../../services/riskService';

interface Props {
  onSelect: (analysisId: string) => void;
  selectedId?: string | null;
  refreshKey?: number;
}

const HistoryPanel: React.FC<Props> = ({ onSelect, selectedId, refreshKey }) => {
  const { token } = useAuth();
  const [items, setItems] = useState<riskService.HistoryItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) { setLoading(false); return; }
    setLoading(true);
    riskService
      .listAnalyses(token, 30)
      .then((r) => {
        setItems(r.analyses || []);
      })
      .catch(() => {/* silent — history is non-critical */})
      .finally(() => setLoading(false));
  }, [token, refreshKey]);

  if (loading) return <div className="history-loading">Loading history...</div>;
  if (items.length === 0) {
    return (
      <div className="history-empty">
        No prior analyses yet. Run your first analysis above.
      </div>
    );
  }

  return (
    <section className="history-panel">
      <h3>Analysis history (last 30)</h3>
      <p className="history-hint">Click any row to view that analysis.</p>
      <table className="history-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Mode</th>
            <th>Risk level</th>
            <th>Headline</th>
            <th>Recs</th>
          </tr>
        </thead>
        <tbody>
          {items.map((it) => (
            <tr
              key={it.analysisId}
              onClick={() => onSelect(it.analysisId)}
              className={`history-row ${selectedId === it.analysisId ? 'history-row-selected' : ''}`}
            >
              <td>{new Date(it.runAt).toLocaleString('en-US', { timeZone: 'America/New_York' })}</td>
              <td>{it.mode}</td>
              <td className={`risk-level-cell risk-${it.overall_risk_level}`}>
                {it.overall_risk_level}
              </td>
              <td>{it.headline}</td>
              <td>{it.rec_count}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
};

export default HistoryPanel;
